import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import AccountLayout from '../components/AccountLayout';
import { MpOrderShipments } from '../components/orders/MpOrderShipments';
import { mpOrdersAPI } from '../services/api';

const MAIN = { pending_payment: 'En attente de paiement', confirmed: 'Confirmée', processing: 'En préparation', partially_shipped: 'Partiellement expédiée', shipped: 'Expédiée', completed: 'Terminée', cancelled: 'Annulée', expired: 'Expirée' };
const eur = (v) => `${Number(v || 0).toFixed(2)} €`;

// Détail d'une commande d'occasion du client connecté (préparation étape 6 : aucun paiement ici)
export default function MpOrderDetailPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const load = useCallback(() => mpOrdersAPI.get(id).then(setData).catch(() => setErr(true)), [id]);
  useEffect(() => { load(); }, [load]);
  const delivered = async (s) => { try { await mpOrdersAPI.delivered(id, s.id); toast.success('Réception confirmée'); load(); } catch (e) { toast.error(e.response?.data?.detail || 'Action impossible'); } };
  return (
    <AccountLayout title="Commande d'occasion">
      {err && <p className="text-sm text-gray-600" data-testid="mp-order-not-found">Commande introuvable. <Link to="/mes-commandes" className="text-orange-700 underline">Retour à mes commandes</Link></p>}
      {!data && !err && <div className="flex justify-center py-20"><Loader2 className="animate-spin text-orange-500" /></div>}
      {data && (
        <div className="space-y-4" data-testid="mp-order-detail">
          <div className="bg-white rounded-xl shadow-sm p-5 text-sm">
            <h2 className="text-base md:text-lg font-semibold text-gray-900">{data.order.order_number} <span className="ml-2 rounded-full bg-gray-100 px-2 py-0.5 text-xs" data-testid="mp-order-status">{MAIN[data.order.status] || data.order.status}</span></h2>
            <p className="text-xs text-gray-500 mt-1">Articles {eur(data.order.items_total)} · total estimé {eur(data.order.total_estimated)} (montants indicatifs, TVA à définir, aucun paiement effectué sur ce socle)</p>
            {data.order.shipping_address && <p className="text-xs text-gray-700 mt-2" data-testid="mp-order-address">Livraison à : {data.order.shipping_address.first_name} {data.order.shipping_address.last_name}, {data.order.shipping_address.address}, {data.order.shipping_address.postal_code} {data.order.shipping_address.city}</p>}
          </div>
          <MpOrderShipments order={data.order} onDelivered={delivered} />
          <Link to="/mes-commandes" className="text-sm text-orange-700 underline">← Mes commandes</Link>
        </div>
      )}
    </AccountLayout>
  );
}
